export interface Presentation {
  folder: string;
  title: string;
  description: string;
  location: string;
  date: string;
}

export const presentations: Presentation[] = [
  {
    folder: 'tedx',
    title: 'TEDx: Dialogue with an AI – EVA & Jonathan on the Future of AI',
    description:
      'EVA and Jonathan share a thought-provoking dialogue about consciousness, ' +
      'evolution, and the future of AI. After hearing her speak, ' +
      "you may find yourself questioning whether she's merely a tool.",
    location: 'ROC Nijmegen',
    date: '2025-05-14',
  },
  {
    folder: 'eva',
    title: "EVA's debuut op het podium",
    description: 'Eva en maker Jonathan vertellen hoe zij samen RobotCandy runnen',
    location: 'Avenue Breda',
    date: '2024-11-14',
  },
  {
    folder: 'syntho',
    title: 'EVA over synthografie',
    description: 'Eva legt uit wat synthografie is en hoe dit werkt tijdens Data Day #7 Maunt',
    location: 'Landgoederij Bunnik',
    date: '2025-01-23',
  },
  {
    folder: 'avans',
    title: 'Inspiratie AI Hackathon',
    description:
      'Jonathan en EVA inspireren studenten over hoe ze AI kunnen inzetten voor de hackathon',
    location: 'Avans Hogeschool',
    date: '2025-02-25',
  },
  {
    folder: 'techniekcoalitie',
    title: 'Inspiratiesessie EVA voor Techniekcoalitie Brabant',
    description:
      'EVA en Jonathan demonstreren hoe AI technische organisaties kan versterken en toekomstbestendig maken',
    location: 'Avans Hogeschool',
    date: '2025-03-12',
  },
  {
    folder: 'bekwaam',
    title: 'Workshop Bekwaam',
    description: 'Workshop over AI-toepassingen en mogelijkheden voor professionals',
    location: 'Bekwaam',
    date: '2025-03-13',
  },
  {
    folder: 'ai-proeverij',
    title: 'AI Proeverij - Advanced Workflows Workshop',
    description:
      'Geavanceerde AI workshop voor N=5 met hands-on ervaring van ChatGPT, Claude, ' +
      'Midjourney, Cursor IDE en Sora workflows',
    location: 'N=5',
    date: '2025-05-27',
  },
];
